import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'calendar-alt-icon',
  templateUrl: './calendar-alt-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CalendarAltIconComponent {}
